import React from 'react';
import PropTypes from 'prop-types';
import { Utils, translate } from 'versafleet-core';
import { connect } from 'react-redux';
import ReduxActions from 'reduxActions';
import JobHelper from 'utils/jobHelper';
import JobType from './jobType';
import JobDetailEdit from './jobDetailEdit';
import TaskDetailEdit from './taskDetailEdit';

const { Helper, FullScreenLoading } = Utils;

class JobNew extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      form: this._getDefaultForm(),
      page: JobHelper.PageConstants.JOB_TYPE,
      taskIndex: null, // Current task index that's being edited
      error: {}, // Used for job detail form
      isChanged: false,
    };
    this.onFormChange = this._onFormChange.bind(this);
    this.setPage = (page) => { this.setState({ page }); };
    this.setTaskIndex = (taskIndex) => { this.setState({ taskIndex }); };
    this.save = this._save.bind(this);
  }

  _getDefaultForm = () => ({
    base_task_attributes: {
      address_attributes: {
        name: '',
        line_1: '',
        line_2: '',
        country: '',
        zip: '',
        contact_person: '',
        contact_number: '',
        email: '',
      },
      time_type: '',
      time_from: null,
      time_to: null,
      time_window_id: null,
    },
    tag_list: [],
    remarks: '',
    attachments_attributes: [],
    tasks_attributes: [],
  });

  _onFormChange(fieldName, value, index, isDelete) {
    if (fieldName === 'tasks_attributes' && Helper.isNullOrUndefined(index)) {
      // Special behavior for tasks attributes, this is not a general behaviour
      this.setState((prevState) => {
        const form = { ...prevState.form };
        form.tasks_attributes.push(value);

        return { form };
      });
    } else if (fieldName === 'base_task_attributes.billing_account_id') {
      if (value && value !== '') {
        this.props.dispatch(ReduxActions.billingAccount.fetch(value));
      }
      this.setState(prevState => ({
        form: Utils.Helper.setFilter(prevState.form, fieldName, value, index, isDelete),
        isChanged: true,
      }));
    } else {
      this.setState(prevState => ({
        form: Helper.setFilter(prevState.form, fieldName, value, index, isDelete),
        isChanged: true,
      }));
    }
  }

  _save() {
    FullScreenLoading.FullScreenLoadingManager.open(this.props.strings.Job.form.saving);

    let form = this.state.form;
    if (this.state.form.job_type === 'p2p') {
      form = {
        ...this.state.form,
        job_type: 'delivery',
        tag_list: this.state.form.tag_list.concat(['Point-to-Point']),
      };
    }

    this.props.dispatch(ReduxActions.job.create(form))
      .then((result) => {
        Utils.Router.transitionTo(`/jobs/${result.job.id}`);
      })
      .catch((error) => {
        this.setState({ error });
      })
      .then(() => {
        FullScreenLoading.FullScreenLoadingManager.close();
      });
  }

  render() {
    const { page, form, taskIndex } = this.state;

    switch (page) {
      case JobHelper.PageConstants.JOB_TYPE:
        return (
          <JobType
            onFormChange={this.onFormChange}
            setPage={this.setPage}
          />
        );
      case JobHelper.PageConstants.JOB_DETAIL_EDIT:
        return (
          <JobDetailEdit
            error={this.state.error}
            form={form}
            isChanged={this.state.isChanged}
            onFormChange={this.onFormChange}
            save={this.save}
            setPage={this.setPage}
            setTaskIndex={this.setTaskIndex}
          />
        );
      case JobHelper.PageConstants.TASK_DETAIL_EDIT:
        return (
          <TaskDetailEdit
            form={form.tasks_attributes[taskIndex] || {}}
            index={taskIndex}
            isChanged={this.state.isChanged}
            onFormChange={this.onFormChange}
            setPage={this.setPage}
            time={{
              time_from: form.base_task_attributes.time_from,
              time_to: form.base_task_attributes.time_to,
              time_type: form.base_task_attributes.time_type,
              time_window_id: form.base_task_attributes.time_window_id,
            }}
          />
        );
      default:
        return false;
    }
  }
}

JobNew.propTypes = {
  dispatch: PropTypes.func.isRequired,
  strings: PropTypes.shape({
    Job: PropTypes.shape({
      form: PropTypes.shape({
        saving: PropTypes.string,
      }),
    }),
  }).isRequired,
};

export default connect()(translate('')(JobNew));
